import { gql } from "@apollo/client";

const recordOrderProductionJobScreenLocationMutation = gql`
  mutation ($location: String!, $orderProductionJobId: ID!) {
    recordOrderProductionJobScreenLocation(
      location: $location
      orderProductionJobId: $orderProductionJobId
    ) {
      errors {
        orderProductionJobId
      }
      updatedOrderProductionJob {
        id
        highDefinitionDigitalStatus
        latestScreenLocation {
          id
          location
        }
        order {
          id
          highDefinitionDigitalStatus
        }
        screenLocationHistory {
          id
          createdAt
          createdBy {
            id
            name(format: FIRST_NAME_LAST_NAME)
          }
          location
        }
      }
      succeeded
    }
  }
`;

export default recordOrderProductionJobScreenLocationMutation;
